/** @format */
import React, { FC, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router'
import styled from 'styled-components'
import { parseTableSearchParams, replaceTableSearchParams } from 'src/utils/url'

export { parseTableSearchParams }

interface TableSearch {
  className?: string
  syncUrl?: boolean
  children?: React.ReactNode
  style?: React.CSSProperties
  paramsKey?: string
  params?: any
  noStyle?: boolean
}

const DescriptionItem: FC<TableSearch> = ({
  className,
  children,
  style,
  syncUrl = true,
  params,
  paramsKey = 'tableSearch',
  noStyle = false
}) => {
  const history = useHistory()
  const location = useLocation()
  const serializedParams = params ? JSON.stringify(params) : ''

  useEffect(() => {
    if (!syncUrl || !params) {
      return
    }
    replaceTableSearchParams(history, location, params, paramsKey)
  }, [syncUrl, serializedParams, paramsKey, history, location.pathname, location.search])

  return (
    <div className={noStyle ? '' : `${className} table-search`} style={style || {}}>
      {children}
    </div>
  )
}

export default styled(DescriptionItem)<TableSearch>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .search_item {
    display: flex;
    align-items: center;
    margin: 0 16px 16px 0;
    .search_item_label {
      margin: 0px 8px 0 0;
    }
  }
`
